export default "__VITE_ASSET__1c20721e__"